import { useEffect, useState } from 'react';
import { getCampagne } from '../services/api';

// Promesse partagée : un seul appel à l'API par chargement de page
let requete = null;

/** 'a_venir' | 'ouverte' | 'cloturee', recalculé à l'instant T (la page peut rester ouverte longtemps). */
export const statutCampagne = (campagne) => {
  if (!campagne) return 'ouverte'; // API injoignable : le serveur reste seul juge au dépôt
  const now = Date.now();
  if (now < new Date(campagne.date_ouverture).getTime()) return 'a_venir';
  if (now > new Date(campagne.date_cloture).getTime()) return 'cloturee';
  return 'ouverte';
};

/** Période de dépôt fixée par l'administration (dates + libellés en heure de N'Djaména). */
const useCampagne = () => {
  const [state, setState] = useState({ campagne: null, loading: true });

  useEffect(() => {
    let active = true;
    if (!requete) {
      requete = getCampagne().catch(() => {
        requete = null;
        return null;
      });
    }
    requete.then((campagne) => {
      if (active) setState({ campagne, loading: false });
    });
    return () => { active = false; };
  }, []);

  return state;
};

export default useCampagne;
